import { ReactElement, ReactNode } from 'react';

interface AlignedButtonsProps {
  children: ReactNode;
}

const PADDING = '8px';

const LeftAlignedButtons = (props: AlignedButtonsProps): ReactElement => {
  const { children } = props;

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-start',
        paddingLeft: PADDING,
        paddingRight: PADDING,
      }}
    >
      {children}
    </div>
  );
};

const CenterAlignedButtons = (props: AlignedButtonsProps): ReactElement => {
  const { children } = props;

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        paddingLeft: PADDING,
        paddingRight: PADDING,
      }}
    >
      {children}
    </div>
  );
};

const RightAlignedButtons = (props: AlignedButtonsProps): ReactElement => {
  const { children } = props;

  return (
    <div
      className="right-aligned-button-container"
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        paddingLeft: PADDING,
        paddingRight: PADDING,
      }}
    >
      {children}
    </div>
  );
};

export { LeftAlignedButtons, CenterAlignedButtons, RightAlignedButtons };
